import React, { useState } from 'react';

import { Collapse } from '@mui/material';

type CollapseDescriptionProps = {
  label: string;
  description: string | undefined;
  emptyText: string;
};

const CollapseDescription = ({
  label,
  description,
  emptyText,
}: CollapseDescriptionProps) => {
  const [checked, setChecked] = useState(false);

  const screenWidth = screen.width;

  const isCollapse = description
    ? description?.length >= (screenWidth > 1600 ? 860 : 420)
    : false;

  const handleSwitch = () => {
    setChecked((prev) => !prev);
  };

  return (
    <div className="flex flex-col gap-2 border border-[#E4E7EC] px-6 py-4">
      <p className="flex-grow font-bold">{label}</p>

      {description?.length ? (
        isCollapse ? (
          <Collapse in={checked} className="relative" collapsedSize={70}>
            <p className="break-all font-normal">{description}</p>
          </Collapse>
        ) : (
          <p className="break-all font-normal">{description}</p>
        )
      ) : (
        <p className="text-gray-400 font-normal">{emptyText}</p>
      )}
      {isCollapse && (
        <button className="text-[#666] text-sm" onClick={handleSwitch}>
          Show {checked ? 'less' : 'more'}
        </button>
      )}
    </div>
  );
};

export default CollapseDescription;
